(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jarvis-foundation"]) return;
  try {
    
  /* THE PAGE'S OWN "ADD TO CART", PRESSED FROM ANY SECTION (2026-09-25, Owner: "the ad to cart
     button at the bottom of the product page is not clickable"). The closing panel, the story
     rows and the comparison linked to `#shopify-section-main`, which Horizon never renders (its
     main section id carries the template id), so the click went nowhere. A `[data-jarvis-cart]`
     link now presses the product form's real submit button - same variant, same cart drawer,
     same sold-out state - and, when that button is disabled (sold out, no option picked),
     brings the buy box into view instead. Without script the link falls back to #MainContent. */
  (function () {
    if (window.__jarvisCartCta) return;
    window.__jarvisCartCta = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-jarvis-cart]');
      if (!link) return;
      var button = document.querySelector(
        'form[action$="/cart/add"] button[type="submit"][name="add"]:not(.sticky-add-to-cart__button)'
      );
      if (!button) return;
      event.preventDefault();
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
        var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        button.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      button.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
